import Vue, { WatchOptions } from 'vue'
import { memoize } from 'vtils'

const getBridge = memoize(() => new Vue())

export function createModel<T extends Record<any, any>>(initialState: T) {
  const state = Vue.observable({ ...initialState })
  const set = (nextState: T) => Object.assign(state, nextState)
  const update = (nextState: Partial<T>) => Object.assign(state, nextState)
  const reset = () => Object.assign(state, initialState)
  const mixin = {
    computed: {
      $state() {
        return state
      },
    },
  }
  const watch = <X>(
    fn: (this: T, state: T) => X,
    cb: (value: X) => any,
    options?: WatchOptions,
  ) => {
    const unwatch = getBridge().$watch(() => fn.call(state, state), cb, options)
    const unwatchBeforeDestroy = (that: any) => {
      that.$once('hook:beforeDestroy', unwatch)
    }
    return {
      unwatch,
      unwatchBeforeDestroy,
    }
  }
  return {
    state,
    set,
    update,
    reset,
    mixin,
    watch,
  }
}
